import { render, staticRenderFns } from "./NewModalWrapper.vue?vue&type=template&id=113ed22a"
import script from "./NewModalWrapper.vue?vue&type=script&lang=js"
export * from "./NewModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports